<template>
  <div>
    <div class="schedule-header-desktop responsive-visible desktop">
      <section class="left-control">
        <el-button
          class="calendar icon-btn ic-arrow-left"
          @click="handleClickPrevDay"
        />
        <el-date-picker
          v-model="curDate"
          :clearable="false"
          style="margin: 0 2px;"
          :type="calendarUnit === 'monthly' ? 'month' : 'date'"
          prefix-icon="none"
          class="el-date-button calendar icon-btn ic-calendar-inactive"
          @change="onChangeDate"
        />
        <el-button
          class="calendar word-btn"
          @click="handleClickToday"
        >
          {{ todayButtonLabel }}
        </el-button>
        <el-button
          class="calendar icon-btn ic-arrow-right"
          @click="handleClickNextDay"
        />
      </section>
	  <h1 v-if='customDateTitle'>{{ customDateTitle }}</h1>
      <h1 v-else>{{ dateHeader }}</h1>
      <section class="right-control">
        <slot name="desktop-control-buttons" />
      </section>
    </div>

    <div class="schedule-header-mobile responsive-visible mobile">
      <div class="left-control">
        <el-date-picker
          v-model="curDate"
          :format="calendarUnit === 'monthly' ? 'yyyy년 M월' : mbDateHeader"
          :clearable="false"
          :editable="false"
          style="margin: 0 2px;"
          :type="calendarUnit === 'monthly' ? 'month' : 'date'"
          prefix-icon="el-icon-arrow-down"
          class="date-header"
          @change="onChangeDate"
        />
      </div>

      <div class="right-control">
        <slot name="mobile-control-buttons" />
      </div>
    </div>
  </div>
</template>

<script>
import dateFns from "date-fns";
import { CALENDAR_DATE_UNIT, WEEKDAY_OPTIONS } from "../constants";

export default {
	name: "DateBasedPageHeader",
	props: {
		calendarUnit: {
			type: String,
			default: "daily",
		},
		value: {
			type: Date,
			default: new Date(),
		},
		todayButtonLabel: {
			type: String,
			default: "오늘",
		},
		customDateTitle: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			curDate: new Date(),
		};
	},
	computed: {
		dateHeader() {
			if (this.calendarUnit === "daily") {
				const day = this.getDay(this.curDate);
				return `${dateFns.format(this.curDate, "YYYY년 M월 D일")} ${day}요일`;
			}
			return dateFns.format(this.curDate, "YYYY년 M월");
		},
		mbDateHeader(){
			const day = this.getDay(this.curDate);
			return `${dateFns.format(this.curDate, "M월 D일")} ${day}요일`;
		}
	},

	watch: {
		value: {
			immediate: true,
			handler() {
				this.curDate = this.value;
			},
		},
	},
	methods: {
		handleClickPrevDay() {
			const addDateUnit =
				dateFns[`add${CALENDAR_DATE_UNIT[this.calendarUnit]}s`];

			this.$emit("input", addDateUnit(this.value, -1));
		},
		handleClickNextDay() {
			const addDateUnit =
				dateFns[`add${CALENDAR_DATE_UNIT[this.calendarUnit]}s`];

			this.$emit("input", addDateUnit(this.value, 1));
		},
		handleClickToday() {
			this.$emit("input", new Date());
		},
		onChangeDate(date) {
			this.$emit("input", date);
		},
		getDay(curDate){
			const optionIndex = curDate.getDay() - 1 < 0 ? 6 : curDate.getDay() - 1;
			const day = WEEKDAY_OPTIONS[optionIndex].label;
			return day;
		}
	},
};
</script>

<style lang="scss">
.schedule-header-desktop {
	position: relative;
	margin-top: 36px;
	margin-bottom: 36px;
	&.desktop{
		display: flex;
		@media screen and (max-width: 768px) {
			display: none;
		}
	}

	h1 {
		text-align: center;
		margin: 0;
		line-height: 42px;
		font-size: 25px;
		letter-spacing: -1px;
		color: #4a4a4a;
		flex: 1;
	}

	.left-control {
		.el-button + .el-button {
			margin-left: 2px;
		}
	}


	@media screen and (max-width: 990px) {
		.calendar{
			font-size: 13px !important;
			&.word-btn{
				padding: 12px 18px !important;
			}

			&.icon-btn{
				background-size: 20px !important;
				background-position: center !important;
				background-position-x: auto !important;
			}

			&.icon-word-btn{
				padding: 10px 12px 10px 25px !important;
				background-size: 15px !important;
			}
		}
		h1{
			font-size: 20px;
		}
		.right-control {
			.schedule-header__radio-group .el-radio-button .el-radio-button__inner{
				padding: 15px 18px;
				font-size: 12px;
			}

		}
	}
}

.schedule-header-mobile {
	margin-top: 12px;
	margin-bottom: 15px;
	position: relative;
	&.mobile{
		display: none;
		@media screen and (max-width: 768px) {
			display: flex;
			.el-button{
				padding: 10px 13px;
			}
			.calendar{
				font-size: 13px;
				&.icon-btn{
				background-size: 20px !important;
				background-position: center !important;
				background-position-x: auto !important;
			}
			}
		}
	}
	.left-control {
		margin: auto auto auto 7px;
		.el-button + .el-button {
			margin-left: 2px;
		}
	}
}
</style>
